import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./CompanyCases.css";

export default function CompanyCases() {
  const { companyId } = useParams();
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCases = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/cases/by-enterprise/${companyId}`, {
        headers: { "ngrok-skip-browser-warning": "true" },
      });

      const data = await res.json();
      console.log("CASES FROM BACKEND:", data);

      setCases(data.cases || []);
      setLoading(false);
    } catch (error) {
      console.error("Error loading cases:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCases();
  }, [companyId]);

  return (
    <>
      <div className="company-cases-container">
        <h1 className="company-cases-title">Company Cases</h1>

        <Link to="/existing-case" className="back-btn">
          â¬… Back to Companies
        </Link>

        {loading ? (
          <p className="loading">Loading...</p>
        ) : cases.length === 0 ? (
          <p className="no-cases">No cases found for this company.</p>
        ) : (
          <div className="cases-list">
            {cases.map((item) => (
              <div key={item._id} className="case-card">
                <h2 className="case-title">{item.caseName || "Company Case"}</h2>

                <p><strong>Created:</strong> 
                  {new Date(item.date_created || item.timestamp).toLocaleDateString()}
                </p>

                <Link
                  to={`/case-details/${item._id}`}
                  className="view-details-btn"
                >
                  View Case
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
